/* eslint-disable react-hooks/exhaustive-deps */
import { Popconfirm, message, Input, ConfigProvider, DatePicker, Radio, Col } from 'antd';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaPlus, FaRegTrashAlt, FaClipboardList } from 'react-icons/fa';
import ptBR from 'antd/lib/locale/pt_BR';
import moment from 'moment';
import DefaultLayout from '~/pages/_layouts/full';
import PageTitle from '~/components/PageTitle';
import Button from '~/components/Button';
import Box from '~/components/Box';
import '../styles.css';
import { TableActions, Table } from '~/components/Table';
import Pagination from '~/components/Pagination';
import errorHandler from '~/Utils/errorHandler';
import api from '~/services/api';
import { useIsMobile } from '~/Utils/isMob';
import Checklist from './forms';
import { SearchCol, TableTop } from './styles';

export default function EntradaSaida() {
  const { t } = useTranslation();
  const isMob = useIsMobile();
  const { idVeiculo } = useParams();

  // modal
  const [modalVisible, setModalVisible] = useState(false);
  const [recordData, setRecordData] = useState([]);
  const [meta, setMeta] = useState({});
  const [loading, setLoading] = useState(false);
  const [checklist, setChecklist] = useState(null);
  const [user, setUser] = useState();
  const [search, setSearch] = useState('');
  const [dateSaida, setDateSaida] = useState('');
  const [dateEntrada, setDateEntrada] = useState('');
  const [radio, setRadio] = useState(0);

  const fetchRecords = async (page = 1) => {
    setLoading(true);
    try {
      const params = {
        params: {
          page,
          search,
          saida: dateSaida,
          entrada: dateEntrada,
          radio,
        },
      };
      const { data } = await api.get(`/controle/${idVeiculo}`, params);

      setRecordData(data.data);
      setMeta(data.meta);
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
    return null;
  };

  const fetchUser = async () => {
    try {
      const { data } = await api.get('/getlogin');
      setUser(data);
    } catch (error) {
      errorHandler(error);
    }
  };

  const handleModal = async checklistId => {
    setLoading(true);
    try {
      if (checklistId) {
        const { data } = await api.get(`/checklist/${checklistId}`);
        setChecklist(data);
      }

      setModalVisible(true);
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
  };

  const handleDelete = async id => {
    setLoading(true);
    try {
      await api.delete(`/controle/${id}/imagens`);
      await api.delete(`controle/${id}`);
      fetchRecords();
      message.success(t('messages:success'));
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchRecords();
    fetchUser();
  }, []);

  useEffect(() => {
    fetchRecords();
  }, [search, dateSaida, dateEntrada, radio]);

  const tableColumns = [
    {
      title: t('screens:veiculos.entradaSaida.data.id'),
      dataIndex: 'id',
      responsive: ['sm'],
      key: 'id',
    },
    {
      title: t('screens:veiculos.entradaSaida.data.motorista'),
      dataIndex: 'checklist_users',
      key: 'nome',
      responsive: ['sm'],
    },
    {
      title: t('Saída'),
      dataIndex: 'saida',
      responsive: ['sm'],
      key: 'saida',
    },
    {
      title: t('Entrada'),
      dataIndex: 'entrada',
      key: 'entrada',
      responsive: ['sm'],
    },
    {
      title: t('screens:veiculos.entradaSaida.data.kmInicial'),
      dataIndex: 'checklist_km_inicial',
      key: 'km_inicial',
      responsive: ['sm'],
    },
    {
      title: t('screens:veiculos.entradaSaida.data.kmFinal'),
      dataIndex: 'checklist_km_final',
      key: 'checklist_km_final',
      responsive: ['sm'],
    },
    {
      title: t('screens:veiculos.entradaSaida.data.actions'),
      dataIndex: 'actions',
      key: 'actions',
      width: '20%',
      align: 'center',
      responsive: ['lg'],
      render: (text, record) => (
        <TableActions align="center">
          {!record.entrada && (user?.type === 'Admin' || record.checklist_users === user?.name) && (
            <Button
              size="small"
              title="Desmobilizar"
              style={{ width: '30%' }}
              onClick={() => {
                handleModal(record.checklist_id);
              }}
            >
              <span style={{ color: '#197ACF' }}>Desmobilizar</span>
              <FaClipboardList />
            </Button>
          )}
          {user?.type === 'Admin' && (
            <Popconfirm
              title={t('messages:confirmDelete')}
              okText={t('messages:yes')}
              onConfirm={() => {
                handleDelete(record.id);
              }}
              cancelText={t('messages:no')}
            >
              <Button size="small" title="Excluir">
                <FaRegTrashAlt style={{ color: 'red' }} />
              </Button>
            </Popconfirm>
          )}
        </TableActions>
      ),
    },
    {
      key: 'summary',
      responsive: ['xs'],
      render: (text, record) => (
        <Col style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <Col>
            <strong>ID:</strong> {record.id}
          </Col>
          <Col>
            <strong>Motorista:</strong> {record.checklist_users}
          </Col>
          <Col>
            <strong>Saída:</strong> {record.saida || '-'}
          </Col>
          <Col>
            <strong>Entrada:</strong> {record.entrada || '-'}
          </Col>
          <Col>
            <strong>KM Inicial:</strong> {record.checklist_km_inicial}
          </Col>
          <Col>
            <strong>KM Final:</strong> {record.checklist_km_final}
          </Col>
          <Col style={{ display: 'flex', gap: 8, marginTop: 4, justifyContent: 'start' }}>
            {!record.entrada && (user?.type === 'Admin' || record.checklist_users === user?.name) && (
              <Button
                title="Desmobilizar"
                onClick={() => handleModal(record.checklist_id)}
                style={{ backgroundColor: 'red' }}
              >
                <span>Desmobilizar</span>
                <FaClipboardList />
              </Button>
            )}
            {user?.type === 'Admin' && (
              <Popconfirm
                title={t('messages:confirmDelete')}
                okText={t('messages:yes')}
                onConfirm={() => handleDelete(record.id)}
                cancelText={t('messages:no')}
              >
                <Button title="Excluir">
                  <FaRegTrashAlt style={{ color: 'red' }} />
                </Button>
              </Popconfirm>
            )}
          </Col>
        </Col>
      ),
    },
  ];

  return (
    <>
      <DefaultLayout>
        <PageTitle title={t('screens:veiculos.entradaSaida.title')}>
          {(recordData[0]?.veiculos?.disponivel || recordData.length === 0) && (
            <Button onClick={() => handleModal(null)} loading={loading} color="info">
              <FaPlus />
              {t('screens:veiculos.entradaSaida.btnNew')}
            </Button>
          )}
        </PageTitle>
        <Box>
          <TableTop isMob={isMob}>
            <Input.Search style={{ width: isMob ? '100%' : '20%' }} onSearch={data => setSearch(data)} />
            <SearchCol style={{ width: isMob ? '100%' : '' }}>
              <span>Saída</span>
              <ConfigProvider locale={ptBR}>
                <DatePicker
                  style={{ width: isMob ? '100%' : '' }}
                  onChange={data => setDateSaida(data ? moment(data).format('YYYY/MM/DD') : '')}
                />
              </ConfigProvider>
            </SearchCol>
            <SearchCol style={{ width: isMob ? '100%' : '' }}>
              <span>Entrada</span>
              <ConfigProvider locale={ptBR}>
                <DatePicker
                  style={{ width: isMob ? '100%' : '' }}
                  onChange={data => setDateEntrada(data ? moment(data).format('YYYY/MM/DD') : '')}
                />
              </ConfigProvider>
            </SearchCol>
            <Col style={{ alignSelf: 'center' }}>
              <Radio.Group
                style={{ width: isMob ? '100%' : '' }}
                defaultValue={0}
                onChange={data => setRadio(data.target.value)}
              >
                <Radio value={0}>Todas</Radio>
                <Radio value={1}>Pendentes</Radio>
                <Radio value={2}>Realizadas</Radio>
              </Radio.Group>
            </Col>
          </TableTop>
          <Table pagination={false} rowKey="id" loading={loading} dataSource={recordData} columns={tableColumns} />
          <Pagination
            onChange={value => {
              fetchRecords(value);
            }}
            meta={meta}
          />
        </Box>
      </DefaultLayout>
      <Checklist
        visible={modalVisible}
        idVeiculo={idVeiculo}
        checklist={checklist}
        onClose={() => {
          setChecklist(null);
          setModalVisible(false);
          fetchRecords();
        }}
      />
    </>
  );
}
